module.exports = __webpack_public_path__ + "static/media/CVsectionimage.74065d7d.png";